import jwtDecode from 'jwt-decode'
import { useEffect } from 'react'

import apiAsync from '../../../utils/api-async'
import { useAuthentication } from 'authentication'
import { useLocation, useSearchParams } from 'react-router-dom'

interface JwtHeader {
  typ?: string
  alg?: string
  kid?: string
}

const useToken = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const location = useLocation()

  const tokenFromUrl = searchParams.get('token')
  const tokenFromLocalStorage = localStorage.getItem('token')
  const newToken = tokenFromUrl || tokenFromLocalStorage

  const { updateAuthData, token: tokenInState } = useAuthentication()

  useEffect(() => {
    const tokenAlreadyUpdated = tokenInState && tokenInState === newToken

    if (!newToken || tokenAlreadyUpdated) return

    try {
      const decodedHeader = jwtDecode<JwtHeader>(newToken, { header: true })
      if (decodedHeader?.typ !== 'JWT' || decodedHeader?.alg !== 'HS256') {
        throw new Error('Invalid token')
      }

      apiAsync.setAuthToken(newToken)

      const decoded = jwtDecode<{
        email: string
        user_id: string
        expiration_date: number
      }>(newToken)

      updateAuthData({
        userName: decoded.email,
        userUuid: decoded.user_id,
        token: newToken,
        expirationDate: decoded.expiration_date
      })

      searchParams.delete('token')
      setSearchParams(searchParams, { replace: true, state: location.state })
    } catch (error) {
      const err = error as { message: string }
      console.log(err.message)
    }
  }, [
    newToken,
    setSearchParams,
    searchParams,
    updateAuthData,
    tokenInState,
    location.state
  ])

  return newToken
}

export default useToken
